import { Report } from '@/shared/api/protocol-ts/model/dto_report_pb';
import { Study } from '@/shared/api/protocol-ts/model/dto_study_pb';

import { getLatestStudyDate } from '@/entities/study';

export const getLatestDate = (
  report: Report | undefined,
  studies: Study[],
): number | undefined => {
  const studyDate = getLatestStudyDate(studies);

  if (studyDate) {
    return studyDate;
  }

  // TODO: [2|m] remove this to separated function
  const reportsDate = report && report.Created?.At;

  if (reportsDate) {
    return reportsDate.toDate().getTime();
  }

  return undefined;
};
